module.exports = __webpack_public_path__ + "img/boho_rio_gift_samba-1.39756ea8.svg";